import { FlucsSchema } from './Flucs.styles';

export const flucsStyles: FlucsSchema = {
  wrapper: {
    pos: 'relative',
    alignItems: 'center',
  },
  innerWrapper: {
    alignItems: 'center',
    bg: 'blackAlpha.500',
    width: 'fit-content',
    borderRadius: 'base',
    boxShadow: 'none',
    p: '2',
    my: '1',
    mr: ['1', '2'],
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2xs',
    fontFamily: 'accent',
  },
  priceTitle: {
    as: 'p',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '2sx',
    mr: '1',
  },
  priceNumber: {
    color: 'white',
  },
  priceText: {
    color: 'white',
    mr: ['1', '2'],
    fontSize: '2xs',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'medium',
  },
  priceTextIncreased: {
    color: 'white',
    fontWeight: 'medium',
  },
  priceIcon: {
    color: 'red.500',
    ml: '1',
    textShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
  },
  priceIconIncreased: {
    color: 'alpha.100',
    transform: 'rotate(180deg)',
  },
  lottieWrapper: {
    alignItems: 'center',
    boxSize: '10',
    borderLeft: '1px solid',
    borderColor: ['transparent', null, 'whiteAlpha.200'],
    ml: '1',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    bg: '#ED8936',
    p: '3',
    display: 'block',
    position: 'relative',
  },
};
